import { render, staticRenderFns } from "./AppointmentProcedureList.vue?vue&type=template&id=c590d9c6&scoped=true&"
import script from "./AppointmentProcedureList.vue?vue&type=script&lang=js&"
export * from "./AppointmentProcedureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c590d9c6",
  null
  
)

export default component.exports